import React, { useState } from "react"
import { Row, Col, Form, Input, Button, Checkbox, Card } from "antd"

import { setJwt } from "../utils/auth"
import { authUrl } from "../utils/api"
import { post } from "../utils/axios"

const Login = () => {
  const [loginFailed, setLoginFailed] = useState(false)
  window.document.body.style.backgroundColor = "#ebedef"

  const onSubmit = async (values) => {
    const response = await post(`${authUrl}/login`, values)

    if (response.isOk) {
      setLoginFailed(false)

      setJwt(response.data.token, values.remember)
      window.location.href = "/"
    } else {
      setLoginFailed(true)
    }
  }

  return (
    <Row style={{ marginTop: 100, height: 350 }}>
      <Col offset={6} span={5}>
        <div style={{ height: "100%", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "#e50100" }}>
          <img height="71px" width="223px" src="/img/armagan-logo.png" />
        </div>
      </Col>
      <Col span={7}>
        <div
          style={{
            height: "100%",
            border: "1px solid #bbb",
            backgroundColor: "white",
            padding: 40
          }}
        >
          <Form name="login-form" className="login-form" layout="vertical" initialValues={{ remember: true }} onFinish={onSubmit}>
            <Form.Item label="Eposta" name="email" rules={[{ required: true, message: "Email gerekli!" }]}>
              <Input placeholder="Eposta" />
            </Form.Item>
            <Form.Item label="Şifre" name="password" rules={[{ required: true, message: "Şifre gerekli!" }]}>
              <Input.Password placeholder="Şifre" />
            </Form.Item>
            {loginFailed && <span style={{ color: "red" }}>Giriş Başarısız!</span>}
            <Form.Item name="remember" valuePropName="checked">
              <Checkbox>Beni hatırla</Checkbox>
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit" className="login-form-button">
                Giriş yap
              </Button>
            </Form.Item>
          </Form>
        </div>
      </Col>
    </Row>
  )
}

export default Login
